module.exports = __webpack_public_path__ + "static/media/Julie Schaub Resume.f4342a3c.pdf";